"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _formatCommodityData = require("../../utils/formatCommodityData");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
const _excluded = ["list"],
  _excluded2 = ["itemList"],
  _excluded3 = ["commodityObject", "href", "btnTxt", "list"];
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const _require = require('@tencent/cms-design-component'),
  PriceSetTab = _require.PriceSetTab;
const formatBuyProduct = properties => {
  const modTitle = properties.modTitle,
    description = properties.description,
    _properties$configura = properties.configuration,
    configuration = _properties$configura === void 0 ? [] : _properties$configura,
    color = properties.color; // 第一条数据是模块名称
  const configurationTemp = configuration.map((productItem, index) => {
    const _productItem$list = productItem.list,
      list = _productItem$list === void 0 ? [] : _productItem$list,
      rest = (0, _objectWithoutProperties2.default)(productItem, _excluded);
    const listTemp = list.map(listItem => {
      const _listItem$itemList = listItem.itemList,
        itemList = _listItem$itemList === void 0 ? [] : _listItem$itemList,
        rest = (0, _objectWithoutProperties2.default)(listItem, _excluded2);
      const itemListTemp = itemList.map(item => {
        const _item$commodityObject = item.commodityObject,
          commodityObject = _item$commodityObject === void 0 ? '{}' : _item$commodityObject,
          _item$href = item.href,
          href = _item$href === void 0 ? '' : _item$href,
          _item$btnTxt = item.btnTxt,
          btnTxt = _item$btnTxt === void 0 ? '' : _item$btnTxt,
          _item$list = item.list,
          list = _item$list === void 0 ? [] : _item$list,
          rest = (0, _objectWithoutProperties2.default)(item, _excluded3);
        const resultCommodityObject = (0, _formatCommodityData.formatCommodityData)(commodityObject);
        const onCallback = function () {
          window.asyncReceiveCommodity(_objectSpread({
            href
          }, resultCommodityObject));
        };
        return _objectSpread(_objectSpread({}, rest), {}, {
          list,
          btnTxt,
          extendProps: {
            'report-event': 'click_price_set_tab_button',
            'report-ext1': index,
            'report-ext2': btnTxt,
            'report-ext3': href
          },
          onCallback
        });
      });
      return _objectSpread({
        itemList: itemListTemp
      }, rest);
    });
    return _objectSpread({
      list: listTemp
    }, rest);
  });
  return {
    modTitle,
    description,
    configuration: configurationTemp || [],
    bgColor: color
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit // {(event: string) => void | Promise<void>} 监听事件
}) {
  if (Object.keys(data).length > 1) {
    const _formatBuyProduct = formatBuyProduct(data),
      _formatBuyProduct$mod = _formatBuyProduct.modTitle,
      modTitle = _formatBuyProduct$mod === void 0 ? '' : _formatBuyProduct$mod,
      _formatBuyProduct$con = _formatBuyProduct.configuration,
      configuration = _formatBuyProduct$con === void 0 ? [] : _formatBuyProduct$con,
      description = _formatBuyProduct.description,
      bgColor = _formatBuyProduct.bgColor;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色

    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_priceSetTab', componentKey, modTitle])), /*#__PURE__*/React.createElement(PriceSetTab, {
      flexTitle: modTitle,
      description: description,
      configuration: configuration.map((item, index) => _objectSpread(_objectSpread({}, item), {}, {
        key: index + 1
      })),
      style: bgStyle
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}